const defaultState = {
    pm: [],//lista de pms
    pmDetail: {},//detalhe de pm com base no msg id
    pmHist:[],//lista de historico do pm
    pmListAllPart: [],//detalhe do pm atual
    fpsOfPM: [],//fps do pm atual
    loading: false,//loading da pagina lista
    loadingHist: false,//loading da pagina form e hist
    errors:{},
    lastFiltersPM:[]
}
  
export default (state=defaultState, action={}) => {
    switch (action.type) {
    
        case 'FETCH_PM_FULFILLED': {
            return {
                ...state,
                pm: action.payload.data,
                loading: false,
                errors: {}
            }
        }
      
        case 'FETCH_PM_PENDING': {
            return {
                ...state,
                loading: true,
                errors: {}
            }
        }
      
        case 'FETCH_PM_REJECTED': {
            return {
                ...state,
                loading: false,
                errors: { global: action.payload.message }
            }
        }

        case 'FETCH_PM_DETAIL_FULFILLED': {
            return {
                ...state,
                pmDetail: action.payload.data[0],
                errors: {},
                loadingHist: false
            }
        }

        case 'FETCH_PM_DETAIL_PENDING': {
            return {
                ...state,
                loadingHist: true,
                pmDetail: {},
                errors: {}
            }
        }
        
        case 'FETCH_PM_DETAIL_REJECTED': {
            return {
                ...state,
                loadingHist: false,
                errors: { global: action.payload.message }
            }
        }      

        case 'FETCH_NEW_PM_FULFILLED': {

            return {
                ...state,
                pmListAllPart: action.payload.data,
                errors: {},
                loading: false
            }
        }

        case 'FETCH_NEW_PM_PENDING': {
            return {
                ...state,
                loading: true,
                errors: {}
            }
        }
        
        case 'FETCH_NEW_PM_REJECTED': {
            return {
                ...state,
                loading: false,
                errors: { global: action.payload.message }
            }
        }      

        case 'FETCH_FPS_FROM_PM_FULFILLED': {
        
            return {
                ...state,
                fpsOfPM: action.payload.data,
                errors: {},
                loading: false
            }
        }

        case 'FETCH_FPS_FROM_PM_PENDING': {
            return {
                ...state,
                loading: true,
                errors: {}
            }
        }
        
        case 'FETCH_FPS_FROM_PM_REJECTED': {
            return {
                ...state,
                loading: false,
                errors: { global: action.payload.message }
            }
        }

        case 'FETCH_PM_HISTORY_FULFILLED': {
            return {
                ...state,
                pmHist: action.payload.data,
                loadingHist: false,
                errors: {}
            }
        }
      
        case 'FETCH_PM_HISTORY_PENDING': {
            return {
                ...state,
                loadingHist: true,
                errors: {}
            }
        }
    
        case 'FETCH_PM_HISTORY_REJECTED': {
            return {
                ...state,
                loadingHist: false,
                errors: { global: action.payload.message }
            }
        }

        case 'LASTFILTER_PM': {      
            return {
                ...state,
                lastFiltersPM: action.payload
            }
        }

        default:
            return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/pm-reducer.js